import React, { useEffect, useRef } from "react";
import "./DownloadApp.css";
import { Link } from "react-router-dom";

const DownloadApp = () => {
  const downloadAppRef = useRef(null);

  useEffect(() => {
    if (window.location.hash === "#DownloadApp" && downloadAppRef.current) {
      downloadAppRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  return (
    <div ref={downloadAppRef} className="DownloadContainer" id="DownloadApp">
      <div
        className="d-flex w-100 justify-content-center "
        style={{ backgroundColor: "transparent" }}
      >
        <div className="DownloadTitle">
          <h3 className="DownloadHeading ">
            All Your Financial Solutions in One Place!
          </h3>
          <p className="DownloandSubHeading py-0">
            Discover smart financial solutions tailored to your needs. Whether
            it's balance transfers, loan consolidation, or flexible top-ups,
            we've got you covered.
          </p>
        </div>
      </div>

      <section className="mobile-app-showcase mt-0 mt-sm-3">
        <div
          className="container down-container"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div className="content">
            <h3 className="title">Experience Minemi on Your Mobile </h3>
            <p className="description">
              Manage loans, check credit scores, and access financial tools on
              the go. Our app puts financial freedom at your fingertips.
            </p>
            <div className="" style={{ background: "transparent" }}>
              <div className=" app-buttons ">
                <Link
                  // to="https://apps.apple.com/in/app/minemi/id6477753054"
                  style={{ backgroundColor: "transparent" }}
                >
                  <img
                    src="https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/google-play-1736947090944.webp"
                    alt="Android"
                    loading="lazy"
                    style={{
                      width: "129px",
                      height: "40px",
                      backgroundColor: "transparent",
                    }}
                  />
                </Link>

                <Link
                  // to="https://apps.apple.com/in/app/minemi/id6477753054"
                  style={{ backgroundColor: "transparent" }}
                >
                  <img
                    src="https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/google-play-two-1736947157870.webp"
                    alt="Apple"
                    loading="lazy"
                    style={{
                      width: "129px",
                      height: "40px",
                      backgroundColor: "transparent",
                    }}
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="mobile-screen p-0">
            <img
              src="https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/download-mobile-app-min-1736927755126.png"
              alt="Downloand App"
              loading="lazy"
              style={{
                width: "19rem",
                height: "35rem",
                backgroundColor: "transparent",
              }}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default DownloadApp;
